<template>
  <Head title="Audience Template Editor" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-2 pt-4">
        <transformation-segment-editor 
          :segments="segments"
          :segment="segment"
          :clients="clients"
          :transformations="transformations"
        ></transformation-segment-editor>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  segments: Array,
  segment: Object,
  clients: Array,
  transformations: Array
});
</script>

